"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var LogoBigPay = function LogoBigPay() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "36",
    height: "26",
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82192 12.6409C3.82192 9.39036 6.53425 6.7418 9.86301 6.7418C12.0822 6.7418 13.9315 7.8253 15.0411 9.63114C15.411 8.30686 16.1507 7.10297 16.8904 6.01946C15.1644 4.21362 12.5753 3.00973 9.86301 3.00973C7.52055 3.00973 5.42466 3.73207 3.82192 5.05635V0H0V12.6409C0 17.938 4.43836 22.272 9.86301 22.272C11.589 22.272 13.1918 21.7905 14.5479 21.0681C15.0411 20.8273 15.411 20.5866 15.9041 20.2254C18.2466 18.4196 19.726 15.771 19.726 12.6409C19.726 11.5574 20.0959 10.4739 20.589 9.63114C21.6986 7.94569 23.5479 6.7418 25.7671 6.7418C29.0959 6.7418 31.8082 9.39036 31.8082 12.6409C31.8082 15.8914 29.0959 18.5399 25.7671 18.5399C23.5479 18.5399 21.6986 17.4564 20.589 15.6506C19.8493 18.1788 18.1233 20.3458 15.9041 21.7905V25.2817H19.726V20.2254C21.4521 21.5497 23.5479 22.272 25.7671 22.272C31.1918 22.272 35.6301 17.938 35.6301 12.6409C35.6301 7.34374 31.1918 3.00973 25.7671 3.00973C22.9315 3.00973 20.4658 4.09324 18.7397 5.89907C18.3699 6.26024 18.1233 6.50102 17.8767 6.86219C16.6438 8.42725 16.0274 10.4739 16.0274 12.5205C16.0274 13.9652 15.5342 15.169 14.6712 16.2526C13.5616 17.5768 11.8356 18.4196 9.9863 18.4196C6.53425 18.5399 3.82192 15.8914 3.82192 12.6409Z",
    fill: "#212124"
  }));
};

var _default = LogoBigPay;
exports.default = _default;